module.exports = __webpack_public_path__ + "static/media/RetailCX.ef464c65.png";